import { render } from "./CategoriesCreate.vue?vue&type=template&id=0a072860&scoped=true"
import script from "./CategoriesCreate.vue?vue&type=script&lang=js"
export * from "./CategoriesCreate.vue?vue&type=script&lang=js"

import "./CategoriesCreate.vue?vue&type=style&index=0&id=0a072860&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a072860"]])

export default __exports__